<div class="container-fluid our-form-background" [ngClass]="addingNewTrainingType ? 'eca-disabled' : ''">
  <div class="row">
    <div class="col">
      <div class="container">
        <div class="row justify-content-between align-items-center">
          <div class="col-auto" style=" padding-left: 0;">
            <label><strong>Training Course</strong></label>
          </div>
          <!--<div class="col-auto p-0 " style="padding-right: 0;">
            <app-eca-ghost-btn class="title-action-button float-right" btnText="Add New Enterprise Training Type/Course"
                               btnIcon="plus-circle" btnType="success" style="margin-top: -12px"
                               *ngIf="!addingNewTrainingType && editing"
                               (btnClicked)="addNewTrainingType()">
            </app-eca-ghost-btn>
          </div>-->
        </div>
      </div>


    </div>
  </div>
  <div class="row" *ngIf="!addingNewTrainingType">
    <div class="col">
      <app-eca-select [options]="trainingTypes" [(selectedId)]="trainingRecord.trainingTypeId"
                      [isValid]="!saveAttempted || !!trainingRecord.trainingTypeSet"
                      validationMessage="Please select the training course for this record"
                      (selectedIdChange)="selectedTrainingTypeChanged()"
                      [isRequired]="true"
                      [isReadOnly]="!editing || addingNewTrainingType"
                      popoverText="Please choose the training course that the operative attended or holds">
      </app-eca-select>

    </div>
  </div>
  <div class="row" *ngIf="addingNewTrainingType">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
      <div class="container eca-outline-border" style="margin-bottom: 20px">
        <div class="row justify-content-between align-items-center">
          <div class="col-auto">
            <h5 class="eca-primary-text h5-relative-font-size">
              Create New Enterprise Training
              Type/Course

            </h5>
          </div>
          <div class="col-auto d-flex align-content-center">
            <app-eca-ghost-btn btnText="Save" btnIcon="save" btnType="success"
                               (btnClicked)="saveNewTrainingType()"></app-eca-ghost-btn>
            <app-eca-ghost-btn btnText="Cancel" btnIcon="edit" btnType="danger"
                               (btnClicked)="cancelNewTrainingType()"></app-eca-ghost-btn>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <app-training-type-editor [editingType]="addingNewTrainingType" [trainingType]="newTrainingType"
                                      [saveAttempted]="saveNewTrainingTypeAttempted"></app-training-type-editor>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
      <div class="container" style="padding-right: 0; padding-left: 0;">
        <div class="form-group">
          <app-eca-html-editor [label]="'Notes for ' + (isMultipleOperatives ? 'these Operatives' : 'this Operative')"
                               popoverText="Enter details about this operative/s attendance/performance"
                               [(content)]="trainingRecord.trainingExtraDescription"
                               [isReadOnly]="!editing || addingNewTrainingType"
                               [isRequired]="false">
          </app-eca-html-editor>
        </div>
      </div>


    </div>
  </div>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="form-group">
        <app-eca-date-picker [isDisabled]="!editing " [controlId]="'ctrlDateAchieved'"
                             label="Achieved On"
                             [(dateValue)]="trainingRecord.achievedOn"
                             (dateValueChange)="disableDatesPriorSelected(trainingRecord.achievedOn)"
                             [maxDate]="selectedMaxDate"
                             [isRequired]="true"
                             [isValid]="!!trainingRecord?.achievedOn?.dateTime"
                             validationMessage="Please enter the date the record was achieved"
                             popoverText="Please enter the date that this training was achieved">
        </app-eca-date-picker>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="form-group">
        <app-eca-date-picker [isDisabled]="!editing || trainingRecord?.achievedOn?.dateTime === undefined || trainingRecord?.achievedOn?.dateTime === null"
                             [controlId]="'ctrlDateValidTo'"
                             label="Valid To"
                             (dateValueChange)="disableDatesPostSelected(trainingRecord.validTo)"
                             [(dateValue)]="trainingRecord.validTo"
                             [minDate]="selectedMinDate"
                             [isRequired]="false"
                             validationMessage="Please enter the date the record is valid to"
                             popoverText="Please enter the date that this training record is valid to">
        </app-eca-date-picker>
      </div>
    </div>
  </div>
  <!--CPD hours-->
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="form-group">
        <app-eca-input label="CPD Hours" [isRequired]="false" [controlId]="'ctrlCPDhours'"
                       [isReadOnly]="!editing"
                       [(value)]="trainingRecord.cpdHour"
                       [inputType]="'number'"
                       popoverText="Please enter how many hours you have spent for CPD"
                       validationMessage="Please enter a Positive Number"
                       required (keydown)="(validate($event))"
                       [isValid]="validateCPD(trainingRecord.cpdHour)"
                       >

          <!--[isValid]="validateCPD(trainingRecord.cpdHour)"-->
        </app-eca-input>
      </div>
    </div>
  </div>
</div>
